import { Action } from "redux";

export const OPEN_MENU = "OPEN_MENU";
export const CLOSE_ALL_OVERLAYS = "CLOSE_ALL_OVERLAYS";

export const OPEN_SEARCH_OVERLAY = "OPEN_SEARCH_OVERLAY";
export const CLOSE_SEARCH_OVERLAY = "CLOSE_SEARCH_OVERLAY";

export const OPEN_FIXR_OVERLAY = "OPEN_FIXR_OVERLAY";
export const CLOSE_FIXR_OVERLAY = "CLOSE_FIXR_OVERLAY";

export interface CloseAllOverlaysAction extends Action {
    type: typeof CLOSE_ALL_OVERLAYS;
}

export interface OpenMenuAction extends Action {
    type: typeof OPEN_MENU;
}

export interface OpenSearchMenuAction extends Action {
    type: typeof OPEN_SEARCH_OVERLAY;
    content?: any;
}

export interface OpenFixrOverlayMenuAction extends Action {
    type: typeof OPEN_FIXR_OVERLAY;
    content?: any;
}

export interface CloseSearchMenuAction extends Action {
    type: typeof CLOSE_SEARCH_OVERLAY;
    content?: any;
}

export type OverlayAction = CloseAllOverlaysAction | OpenMenuAction;
